import SelectFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/SelectFilterSpec";
import IdFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/IdFilterSpec";

class FilterBuilder{
    constructor() {
        this.filterSpecs = [];
    }

    build(){
        return this.filterSpecs;
    }

    withId(fieldName, id){
        this.filterSpecs.push({
            type: IdFilterSpec.prototype.__cls__,
            fieldName,
            filterSpec: {
                idValues: [id],
            }
        });
        return this;
    }

    withValue(fieldName, value){
        this.filterSpecs.push({
            type: SelectFilterSpec.prototype.__cls__,
            fieldName,
            filterSpec: {
                mergeTree: false,
                idValues: [value]
            }
        });
        return this;
    }

    withValues(fieldName, values){
        this.filterSpecs.push({
            type: SelectFilterSpec.prototype.__cls__,
            fieldName,
            filterSpec: {
                mergeTree: false,
                idValues: values
            }
        });
        return this;
    }
}

export default function filterBuilder(){
    return new FilterBuilder();
}